var MDB = window.MDB || {};

(function(){
    function copyToClipboardLegacy(text){
        //Fallback to old document API
        //Document API is not guaranteed to have copied the value to the clipboard
        //even if it returned 'true'
        
        return $.Deferred(function(d){
            //Create a temporary element holding our value
            var tmp = document.createElement('input');
            tmp.value = text;
            document.body.appendChild(tmp);

            //Our element needs to be selected for the command to actually work
            tmp.select();

            //Execute our copy command
            //Resolve when successful
            if(document.execCommand('copy')){
                //Finally, we can get rid of our temp element
                document.body.removeChild(tmp);
                d.resolve();
            } else{
                //Finally, we can get rid of our temp element
                document.body.removeChild(tmp);
                d.reject();
            }
        }).promise();
    }
    
    function copyToClipboardDirect(text){
        //https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/Interact_with_the_clipboard

        //Prefer the new clipboard api
        if(!navigator.permissions || !navigator.permissions.query){
            //Can't check permissions without an API
            return navigator.clipboard.writeText(text);
        }
        
        //We may be blocked from using the clipboard API when we don't have the required permissions
        if(navigator.permissions && navigator.permissions.query){
            //Request permission prior to writing
            return $.Deferred(function(d){
                //clipboard-write is currently only supported in Chromium based browsers
                //even if our permission query fails, we should still attempt to invoke the writeText function
                navigator.permissions.query({name: 'clipboard-write'})
                    .then(function(result) {
                        //We can write only after having received explicit permission
                        if(result.state === "granted" || result.state === "prompt") {
                            //Only after getting explicit permission from the browser are we allowed
                            //to write to the clipboard
                            navigator.clipboard.writeText(text).then(
                                function(){
                                    d.resolve.apply(d, arguments);
                                },
                                function(){
                                    d.reject.apply(d, arguments);
                                }
                            );

                            return;
                        }

                        d.reject(result);
                    },
                    function(){
                        navigator.clipboard.writeText(text).then(
                            function(){
                                d.resolve.apply(d, arguments);
                            },
                            function(){
                                d.reject.apply(d, arguments);
                            }
                        );
                    });
            });
        }
    }

    var copyToClipboardImpl = copyToClipboardDirect;

    if(!navigator || !navigator.clipboard || !navigator.clipboard.writeText){
        copyToClipboardImpl = copyToClipboardLegacy;
    }
    
    $.extend(MDB, {
        /**
         * Copy the given input to the clipboard
         * @param {Object} input
         */
        copyToClipboard: function(input){
            //Ensure we have either a jQuery object or a string value
            //For non string values (eg. an integer) jQuery may contain a non zero length
            //upon invoking the `val()` function however, jQuery attempts to read from the underlying node - which in turn causes a crash 
            if(
              !(input instanceof $) &&
              typeof input !== 'string'
            ) {
                input = input.toString();
            }
            
            //Assume our input is either a jQuery object, or a direct value
            var $input = $(input), 
              text = $input.length >= 1 ? $input.val() : input;

            copyToClipboardImpl(text)
                .then(
                    function() {
                        MDB.Notify.bootstrapSuccess(MDB.loadResourceString('MarketingDb_CopyToClipboard_Success_Text')); 
                    },
                    function() {
                        MDB.Notify.bootstrapWarning(MDB.loadResourceString('MarketingDb_CopyToClipboard_Error_Text')); 
                    }
                );
        }
    });
}());